import React from 'react';
import { EventCategoryPage } from '../../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../../data/eventCategoryData';
const InPerson = () => <EventCategoryPage config={EVENT_CATEGORIES['book-clubs-in-person']} data-id="element-9151" data-mp="1j6tpgi6ynqac" />;
export default InPerson;